import React, { useRef, useState } from "react";
import { CircularProgress, IconButton, InputAdornment, Tooltip } from "@material-ui/core";
import { Translate } from "@material-ui/icons";
import { googleTranslate } from "./googleTranslate";

type TranslateButtonProps = {
  text: string;
  from: string;
  fromLabel: string;
  to: string;
  onTranslated: (text: string) => void;
  disabled?: boolean;
};

const TranslateButton: React.VFC<TranslateButtonProps> = ({
  text,
  from,
  fromLabel,
  to,
  onTranslated,
  disabled = false,
}) => {
  const [translating, setTranslating] = useState(false);
  const latestOnTranslated = useRef(onTranslated);
  latestOnTranslated.current = onTranslated;
  const label = `Auto-translate from ${fromLabel}`;

  const translate = () => {
    setTranslating(true);
    googleTranslate(text, from, to)
      .then(translated => latestOnTranslated.current(translated))
      .catch(() => undefined)
      .finally(() => setTranslating(false));
  };

  return (
    <InputAdornment position="end">
      <Tooltip title={label}>
        <span>
          <IconButton
            size="small"
            aria-label={label}
            disabled={disabled || translating || !text.trim()}
            onClick={translate}
          >
            {translating ? <CircularProgress size={14} /> : <Translate fontSize="small" />}
          </IconButton>
        </span>
      </Tooltip>
    </InputAdornment>
  );
};

export default TranslateButton;
